<template>
  <v-dialog :value="value" @input="$emit('input', $event)" max-width="400">
    <v-card>
      <slot name="title"> </slot>
      <slot name="text">
        <p class="mx-4 mb-0 title custom-text">
          <slot>Confirm to delete item?</slot>
        </p>
      </slot>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="#29284c"
          small
          :loading="loading"
          outlined
          class="text-capitalize"
          @click="$emit('input', false)"
        >
          <slot name="cancelText">No</slot>
        </v-btn>
        <v-btn
          v-if="!hideAccept"
          color="#29284c"
          :loading="loading"
          class="white--text ml-2 text-capitalize"
          depressed
          small
          @click="$emit('yes')"
        >
          <slot name="acceptText">Yes</slot>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  props: {
    value: Boolean,
    loading: Boolean,
    hideAccept: Boolean,
  },
};
</script>
